"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yearListAll = exports.videoOpenClassType = exports.videoOpenClass = exports.resourceType = exports.projectLevel = exports.professionalResourceLibraryType = exports.professionalResourceLibrary = exports.mediaType = exports.industryListAll = exports.industryCategory = exports.getMatchMajorListAll = exports.excellentCourse = exports.courseSource = exports.courseProject = exports.courseLevel = exports.contestType = exports.contestNoticeDetail = exports.contestNotice = exports.applicationType = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
//赛事专栏 比赛类型 查询全部
var contestType = exports.contestType = function contestType(data) {
  return _api.default.request({
    url: '/contestType/getListAll',
    method: 'post',
    data: data
  });
};
//赛事专栏 公告详情
var contestNoticeDetail = exports.contestNoticeDetail = function contestNoticeDetail(data) {
  return _api.default.request({
    url: '/contestNotice/getContestNotice',
    method: 'post',
    data: _qs.default.stringify(data)
  });
};
//赛事专栏 赛事公告 分页查询
var contestNotice = exports.contestNotice = function contestNotice(data) {
  return _api.default.request({
    url: '/contestNotice/getList',
    method: 'post',
    data: data
  });
};
//视频公开课类型
var videoOpenClassType = exports.videoOpenClassType = function videoOpenClassType(data) {
  return _api.default.request({
    url: '/videoOpenClassType/getListAll',
    method: 'post',
    data: data
  });
};
//视频公开课分页查询
var videoOpenClass = exports.videoOpenClass = function videoOpenClass(data) {
  return _api.default.request({
    url: '/videoOpenClass/getList',
    method: 'post',
    data: data
  });
};
//数字课程项目
var courseProject = exports.courseProject = function courseProject(data) {
  return _api.default.request({
    url: '/courseProject/getListAll',
    method: 'post',
    data: data
  });
};
//精品在线课程分页查询
var excellentCourse = exports.excellentCourse = function excellentCourse(data) {
  return _api.default.request({
    url: '/excellentCourse/getList',
    method: 'post',
    data: data
  });
};
//专业资源库分页查询
var professionalResourceLibrary = exports.professionalResourceLibrary = function professionalResourceLibrary(data) {
  return _api.default.request({
    url: '/professionalResourceLibrary/getList',
    method: 'post',
    data: data
  });
};
//课程来源
var courseSource = exports.courseSource = function courseSource(data) {
  return _api.default.request({
    url: '/courseSource/getListAll',
    method: 'post',
    data: data
  });
};
//产业分类
var industryListAll = exports.industryListAll = function industryListAll(data) {
  return _api.default.request({
    url: '/system/web/getIndustryClassificationListAll',
    method: 'post',
    data: data
  });
};
//行业门类
var industryCategory = exports.industryCategory = function industryCategory(data) {
  return _api.default.request({
    url: '/system/web/getClassificationListAll',
    method: 'post',
    data: data
  });
};
//项目级别
var projectLevel = exports.projectLevel = function projectLevel(data) {
  return _api.default.request({
    url: '/system/web/getProjectLevelListAll',
    method: 'post',
    data: data
  });
};
//资源库类型
var resourceType = exports.resourceType = function resourceType(data) {
  return _api.default.request({
    url: '/resourceType/getListAll',
    method: 'post',
    data: data
  });
};
//资源库分类
var professionalResourceLibraryType = exports.professionalResourceLibraryType = function professionalResourceLibraryType(data) {
  return _api.default.request({
    url: '/professionalResourceLibraryType/getListAll',
    method: 'post',
    data: data
  });
};
//层次管理
var courseLevel = exports.courseLevel = function courseLevel(data) {
  return _api.default.request({
    url: '/system/web/getCourseLevelListAll',
    method: 'post',
    data: data
  });
};
//年份管理
var yearListAll = exports.yearListAll = function yearListAll(data) {
  return _api.default.request({
    url: '/system/web/getYearListAll',
    method: 'post',
    data: data
  });
};
//应用类型
var applicationType = exports.applicationType = function applicationType(data) {
  return _api.default.request({
    url: '/applicationType/getListAll',
    method: 'post',
    data: data
  });
};
//媒体类型
var mediaType = exports.mediaType = function mediaType(data) {
  return _api.default.request({
    url: '/mediaType/getListAll',
    method: 'post',
    data: data
  });
};
//专业大类
var getMatchMajorListAll = exports.getMatchMajorListAll = function getMatchMajorListAll(data) {
  return _api.default.request({
    url: '/matchMajor/getMatchMajorListAll',
    method: 'post',
    data: data
  });
};